<!--
  出水水质分析
-->

<template>
  <div class="send_out_water">
    <ContentSection :title="'出水水质分析'" :mainStyle="{ borderRightStyle: 'solid' }">
      <header>
        <p>近24小时{{this.selectValue.value}}统计</p>
        <div class="select">
          <a href="javascript:">{{selectValue.value}}</a>
          <ul class="options">
            <li v-for="(item, index) in  options" :key="index" @click="handleOptions(item)">{{ item.value }}</li>
          </ul>
        </div>
      </header>
      <div class="water_main">
        <div class="my_chart"></div>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import * as echarts from "echarts";
import ContentSection from "@/components/ContentSection";
import { getHistoryByConfig } from "@/api/basic.js"

export default {
  name: "waterChart",
  components: {
    ContentSection,
  },
  data() {
    return {
      chartData: {
        xAxis: [],
        //数据
        yData: [],
      },
      // echart容器
      myChart: null,
      selectValue: {
        id: '1',
        value: '化学需氧量'
      },
      options: [
        {
          id: '1',
          value: '化学需氧量'
        },
        {
          id: '2',
          value: '氨氮'
        },
        {
          id: '3',
          value: '总氮'
        },
        {
          id: '4',
          value: '总磷'
        },
        {
          id: '5',
          value: 'PH'
        },
        {
          id: '6',
          value: '悬浮物'
        },
      ],
    };
  },
  mounted() {
    this.setEcharts()
    // this.getData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.myChart.resize();
    });
  },
  methods: {
    // 获取数据
    getData() {
      console.log(this.$formatDate(new Date()))
      const data = {
        analyzeDate:this.$formatDate(new Date()).year,
        stagetype:2,
        indicattype:this.selectValue.id
      }
      getHistoryByConfig(data).then(res => {
        console.log(res)
        if (res.errorcode == 0) {
          this.setEcharts(res.resultdata.rows[0].HistoryList)
        }
      })
    },

    // 单击下拉选项
    handleOptions(obj){
      this.selectValue = {...obj}
      // this.getData();
      this.setEcharts()
    },
    // 配置chart的option数据
    setOption() {
      return {
        grid: {
          top: "0",
          left: "30px",
          right: 0,
          bottom: "30px",
        },
        // 配置图例
        legend: {
          show: false,
          icon: "circle",
          top: -5,
          // itemWidth: parseInt(this.$chartResize.textResize(15)),
          // itemHeight: parseInt(this.$chartResize.textResize(15)),
          itemWidth: 5,
          itemHeight: 5,
          textStyle: {
            color: "#fff",
            // fontSize: this.$chartResize.textResize(36),
            fontSize: 20,
          },
        },
        // 指示线
        // axisPointer: {
        //   show: true,
        //   label: {
        //     show: false,
        //   },
        // },
        tooltip: {
          trigger: "axis", // 坐标轴指示器触发方式 item、axix、none
          showContent: false
        },
        // 配置x轴线
        xAxis: {
          data: this.chartData.xAxis,
          axisLabel: {
            color: "#fff",
            interval: 0,
            textStyle: {
              // fontSize: this.$chartResize.textResize(18),
              fontSize: 6,
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.5)",
              type: "dotted",
            },
          },
        },
        // 配置y轴
        yAxis: {
          // interval: 200,
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            textStyle: {
              // fontSize: this.$chartResize.textResize(18),
              fontSize: 6,
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.5)",
              type: "dotted",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        // 配置数据记图标样式
        series: [
          // 出水
          {
            type: "line",
            name: "近24小时化学需氧屋统计",
            data: this.chartData.yData,
            showSymbol: false,
            smooth: true,
            lineStyle: {
              color: "#80c7ff",
              width: 1,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0.3,
                    color: "rgba(0,143,255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0,143,255,0)",
                  },
                ],
              },
            },
          },
        ],
      };
    },
    // 配置echarts
    setEcharts(data) {
      this.chartData ={
        xAxis:[],
        yData:[]
      }
      for(let i =0;i<8;i++){
        this.chartData.xAxis.push(this.$formatDate(new Date() - i*3600).hours)
        this.chartData.yData.push(Math.random() *(20-15+1)+15);
      }
      // data.map(item=>{
      //   this.chartData.xAxis.push(this.$formatDate(new Date(item.TimeStamp)).hours);
      //   this.chartData.yData.push(item.ParamValue);
      // })
      this.myChart = echarts.init(
        document.querySelector(".send_out_water .my_chart")
      );
      // 折线图参数

      this.myChart.setOption(this.setOption());
      // echart自适应
      window.addEventListener("resize", () => {

        console.log(this.myChart)
        this.myChart.setOption(this.setOption());
        this.$chartResize.chartResize(this.myChart);
      });
    },
  },
};
</script>

<style lang='less' scoped>
.send_out_water {
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 810px;
    margin: auto;
    padding-top: 40px;

    p {
      font-size: 36px;
      color: #fafafa;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #008fff;
        margin-right: 10vw*@vw;
      }
    }

    .select {
      width: 275px;
      height: 56px;
      border-radius: 10vw *@vw;
      border: 2vw *@vw solid #b4e6ff;
      background: rgba(12, 155, 255, 0.28);
      position: relative;
      color: #fff;
      z-index: 5000;

      &:hover ul {
        display: block;
      }

      &::after {
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border: 14px solid #fff;
        border-left-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        position: absolute;
        top: 24px;
        right: 15px
      }

      ul {
        width: 100%;
        height: 310px;
        display: none;
        border: 2vw*@vw solid #b4e6ff;
        background: rgba(12, 155, 255, 0.28);
        position: absolute;
        top: 56px;
        left: -1px;
        overflow: hidden;
        overflow-y: scroll;

        li {
          cursor: pointer;

          &:hover {
            background-color: rgba(12, 155, 255, 0.5);
          }
        }
      }
    }
  }

  .water_main {
    width: 100%;
    height: 100%;
    display: flex;

    .my_chart {
      margin: auto;
      width: 817px;
      height: 530vh * @vh;
    }
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
  .send_out_water {
    header {
      width: 570px;
      padding-top: 10px;
      p {
        font-size: 24px;
        &::before {
          content: '';
          display: inline-block;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #008fff;
          margin-right: 10vw*@vw;
        }
      }

      .select {
        width: 150px;
        height: 26px;
        line-height: 28px;
        border-radius: 5vw *@vw;
        &::after {
          content: '';
          border-width: 6px;
          top: 12px;
        }
        ul {
          width: 100%;
          height: 200px;
          display: none;
          top: 30px;
        }
      }
    }
    .water_main {
      width: 100%;
      height: 100%;
      display: flex;

      .my_chart {
        margin: auto;
        width: 617px;
        height: 530vh * @vh;
      }
    }
  }
}
</style>